var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYandex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1309 1581",
    width: 1309,
    height: 1581,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pFHvdMV7_0kRsAw7bKuFiP0mY-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #fc3f1d }\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m792.7 1312.1v268.3h-274.6v-452.4l-518.1-1127.3h286.5l403.7 881.9c77.8 168.5 102.5 227.1 102.5 429.5zm516.2-1311.4l-336.8 763.8h-279.1l336.8-763.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.c50dc49a.svg";
export { ForwardRef as ReactComponent };